import { styled } from '@linaria/react';
import { colors, fonts, semantic, space } from '../../theme/tokens';

export const Pill = styled.button`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  padding: ${space[3]} ${space[4]};
  border-radius: 24px;
  border: 1px solid ${colors.black};
  background: transparent;
  color: ${colors.black};
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  white-space: nowrap;

  &[data-selected='true'] {
    background: ${colors.black};
    color: ${colors.white};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &[data-variant='display'] {
    font-size: ${fonts.size.xs};
    font-weight: ${fonts.weight.normal};
    padding: ${space[2]} ${space[3]};
    border: none;
    background: ${semantic.bg.surfaceSubtle};
    color: ${semantic.text.primary};
    cursor: default;
  }
`;
